// ============================================================
// App — top-level routing for the marketing site
//
// Uses wouter (~1KB) instead of react-router-dom. The site has
// a tiny number of routes and we want every byte to count.
// See apps/marketing/DESIGN.md §4.6.
// ============================================================

import { useEffect } from 'react';
import { Route, Switch, useLocation } from 'wouter';
import Nav from './components/Nav';
import Footer from './components/Footer';
import Home from './pages/Home';
import RequestAccess from './pages/RequestAccess';
import RequestSubmitted from './pages/RequestSubmitted';
import Legal from './pages/Legal';
import DataDeletion from './pages/DataDeletion';
import DataDeletionStatus from './pages/DataDeletionStatus';
import NotFound from './pages/NotFound';

function ScrollToTop() {
  const [location] = useLocation();
  useEffect(() => {
    // Skip if URL has a hash anchor (let browser handle it)
    if (window.location.hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [location]);
  return null;
}

export default function App() {
  return (
    <div className="flex min-h-screen flex-col bg-ink text-chalk">
      <ScrollToTop />
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[100] focus:rounded-pill focus:bg-signal focus:px-4 focus:py-2 focus:text-sm focus:font-bold focus:text-ink"
      >
        Skip to content
      </a>
      <Nav />
      <main id="main" className="flex-1">
        <Switch>
          <Route path="/" component={Home} />
          <Route path="/request-access" component={RequestAccess} />
          <Route path="/request-submitted" component={RequestSubmitted} />
          <Route path="/legal/terms">
            <Legal page="terms" />
          </Route>
          <Route path="/legal/privacy">
            <Legal page="privacy" />
          </Route>
          <Route path="/legal/dpa">
            <Legal page="dpa" />
          </Route>
          <Route path="/data-deletion" component={DataDeletion} />
          <Route path="/data-deletion-status" component={DataDeletionStatus} />
          <Route component={NotFound} />
        </Switch>
      </main>
      <Footer />
    </div>
  );
}
